import { MinusCircleOutlined } from '@ant-design/icons'
import { Button, Flex, Form, InputNumber, Select } from 'antd'
import { FC } from 'react'
import Material from '../../../../../types/api/material'
import { ConsumptionFormValues, MaterialTypeOption } from '../types'

interface MaterialRowProps {
    name: number
    rest: { fieldKey?: number }
    typeOptions: { value: string; label: string }[]
    types: MaterialTypeOption[]
    canRemove: boolean
    onRemove: () => void
}

const MaterialRow: FC<MaterialRowProps> = ({
    name,
    rest,
    typeOptions,
    types,
    canRemove,
    onRemove,
}) => {
    const form = Form.useFormInstance<ConsumptionFormValues>()
    const typeId = Form.useWatch(['materials', name, 'materialTypeDocumentId'], form)
    const type = types.find(item => item.documentId === typeId)
    const materials = [...(type?.materials || [])].sort((a, b) => (a.width ?? 0) - (b.width ?? 0))

    return (
        <Flex gap={8} align="start" style={{ marginBottom: 8 }}>
            <Form.Item
                {...rest}
                name={[name, 'materialTypeDocumentId']}
                style={{ flex: 1, marginBottom: 0 }}
                rules={[{ required: true, message: 'Выберите тип материала' }]}
            >
                <Select
                    placeholder="Тип материала"
                    options={typeOptions}
                    showSearch
                    optionFilterProp="label"
                    onChange={() => {
                        form.setFieldValue(['materials', name, 'materialDocumentId'], undefined)
                    }}
                />
            </Form.Item>

            <Form.Item
                {...rest}
                name={[name, 'materialDocumentId']}
                style={{ width: 100, marginBottom: 0 }}
                rules={[{ required: true, message: 'Выберите ширину' }]}
            >
                <Select
                    placeholder="Ширина"
                    disabled={!typeId}
                    options={materials.map((material: Material) => ({
                        value: material.documentId,
                        label: String(material.width),
                    }))}
                    onChange={value => {
                        const material = materials.find(m => m.documentId === value)
                        form.setFieldValue(['materials', name, 'width'], material?.width)
                    }}
                />
            </Form.Item>

            <Form.Item
                {...rest}
                name={[name, 'amount']}
                style={{ width: 120, marginBottom: 0 }}
                rules={[{ required: true, message: 'Укажите длину' }]}
            >
                <InputNumber
                    placeholder="Длина, км"
                    min={0}
                    step={0.001}
                    precision={3}
                    decimalSeparator=","
                    style={{ width: '100%' }}
                />
            </Form.Item>

            <Form.Item
                {...rest}
                name={[name, 'layerNumber']}
                style={{ width: 110, marginBottom: 0 }}
                rules={[
                    { required: true, message: 'Укажите слой' },
                    {
                        type: 'number',
                        transform: value => (value == null ? value : Number(value)),
                        message: 'Слой должен быть числом',
                    },
                ]}
            >
                <InputNumber placeholder="Слой" precision={0} style={{ width: '100%' }} />
            </Form.Item>

            {canRemove && (
                <Button type="text" danger icon={<MinusCircleOutlined />} onClick={onRemove} />
            )}
        </Flex>
    )
}

export default MaterialRow